// Truncate a long selected value with an ellipsis instead of widening the field.
export default {
  select: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
